import {Columns} from 'compob2b-table';
import {translations} from '../../../../environments/translations.ru';

export const FILES_FORM: Columns[] = [
  {
    key: 'header',
    title: translations.header,
    placeholder: translations.header,
    searchEnabled: false,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
  },
  {
    key: 'damCatalogId',
    title: translations.catalog,
    placeholder: translations.catalog,
    formly: true,
    type: 'dam-catalog-picker',
    templateOptions: {
      chooseOnlyLastLevel: false
    },
    width: '100%'
  },
  {
    key: 'size',
    title: translations.size,
    placeholder: translations.size,
    searchEnabled: false,
    grid: true,
    type: 'input',
    required: true,
  },
  {
    key: 'startDate',
    title: translations.startDate,
    placeholder: translations.startDate,
    searchEnabled: false,
    formly: true,
    grid: true,
    type: 'date',
    defaultValue: new Date(),
  },
  {
    key: 'endDate',
    title: translations.endDate,
    placeholder: translations.endDate,
    searchEnabled: false,
    formly: true,
    grid: true,
    type: 'date',
    defaultValue: new Date(),
  },
  {
    key: 'mimeType',
    title: translations.mime,
    placeholder: translations.mime,
    searchEnabled: false,
    grid: true,
    type: 'input',
    required: true,
  },
  {
    key: 'approved',
    title: translations.dam.approved,
    placeholder: translations.dam.approved,
    searchEnabled: false,
    formly: true,
    defaultValue: true,
    type: 'checkbox'
  },
  {
    key: 'enabled',
    title: translations.enabled,
    placeholder: translations.enabled,
    searchEnabled: false,
    formly: true,
    grid: true,
    defaultValue: true,
    type: 'checkbox'
  },
  {
    key: 'action',
    title: translations.action,
    placeholder: translations.action,
    searchEnabled: false,
    grid: true,
    width: '20%',
    type: 'input',
    required: true
  }
];
